import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import "photoswipe/style.css";

export const initPhotoGallery = () => {
	if (!document.querySelector(".photo-gallery")) return;
	initPhotoswipeGalleries();
};

const initPhotoswipeGalleries = () => {
	const galleries = document.querySelectorAll(".photo-gallery");

	galleries.forEach((gallery) => {
		const lightbox = new PhotoSwipeLightbox({
			gallery,
			children: ".photo-gallery__link",
			pswpModule: PhotoSwipe,
			bgOpacity: 0.92,
			showHideAnimationType: "zoom",
		});

		lightbox.init();
	});
};
